import { ref } from 'vue'

export function usePagination(defaultLimit: number = 50) {
	const limit = ref<number>(defaultLimit)
	const offset = ref<number>(0)

	function nextPage() {
		offset.value = offset.value + limit.value
	}

	function prevPage() {
		offset.value = Math.max(0, offset.value - limit.value)
	}

	function reset() {
		offset.value = 0
	}

	return {
		limit,
		offset,
		nextPage,
		prevPage,
		reset
	}
}

